import {Box, HStack, Icon, Text} from "@chakra-ui/react";
import {HiOutlineChevronUp} from "react-icons/hi2";

const ChatTab = ({chat, onPress: onClick}) => {

    const handleOnClick = () => {
        onClick && onClick();
    }
    
    return (
        <HStack color={'white'} bg={'bg.chatTab'} py={6} px={4} w={'full'} borderTopRadius={8} cursor={'pointer'} onClick={handleOnClick}
                justifyContent={'space-between'} borderWidth={1} borderColor={'border.primary'} borderBottomWidth={0}>
            <HStack>
                <Text fontSize={14} fontWeight={600}>{chat?.name} ({chat?.id.substr(chat?.id.length - 5)})</Text>
                <Box bg={'green.600'} w={2} h={2} borderRadius={'full'}/>
            </HStack>
            <Icon fontSize={22} strokeWidth={1.5} color={'white'}>
                <HiOutlineChevronUp/>
            </Icon>
        </HStack>
    )
}

export default ChatTab;